import { useState } from "react";

export default function WhatsAppFloat() {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {hovered && (
        <div className="bg-white rounded-xl px-4 py-3 text-sm text-[#0A1F44] font-medium whitespace-nowrap border border-gray-100 animate-fade-in">
          ¡Escríbenos ahora! 👋
        </div>
      )}
      <a
        href="https://wa.me/523325077743?text=Hola,%20me%20interesa%20conocer%20más%20sobre%20el%20Instituto%20Ashaika"
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="relative w-16 h-16 flex items-center justify-center rounded-full bg-[#25D366] text-white cursor-pointer hover:scale-110 transition-transform duration-300"
        aria-label="Contactar por WhatsApp"
      >
        {/* Pulse rings */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30"></span>
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" style={{ animationDelay: "0.5s" }}></span>
        <i className="ri-whatsapp-line text-3xl relative z-10"></i>
      </a>
    </div>
  );
}
